<div>
    <div>
        <div>
            <div class="wrapper-position">
                <div class="left-section">
                    <h1>{{translation['Welcome']}} {{firstName}}</h1>
                    <div class="membership-no">{{translation['membershipNoLine']}} {{membershipNo}}</div>
                    <div class="sub-title">{{translation['subTitleLine']}}</div>
                    <img src="./assets/shared_image.png">
                    <div class="rank-name">Novice Dynamo</div>
                    <div class="badge-title">{{translation['badgeTitleLine']}}</div>
                    <div class="next-step">
                        <!-- Register yourself in our app for the next steps. -->
                        <div class="next-step-container">
                            <div class="next-step-title">{{translation['nextStepTitle']}}</div>
                            <ol>
                                <li>{{translation['listLine1']}}</li>
                                <li>{{translation['listLine2']}}</li>
                                <li>{{translation['listLine3']}}</li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div class="right-section">
                    <div class="result-title">
                        <div class="app-links">
                            <div>
                                <img [ngClass]="{'selected-img' : selectedStore == 'Apple'}" src="./assets/apple-store.svg" (click)="selectAppLink('Apple')">
                            </div>
                            <div>
                                <img [ngClass]="{'selected-img' : selectedStore == 'Playstore'}" src="./assets/google-store.svg" (click)="selectAppLink('Playstore')">
                            </div>
                            <div>
                                <img [ngClass]="{'selected-img' : selectedStore == 'Huawei'}" src="./assets/huawei-store.svg" (click)="selectAppLink('Huawei')">
                            </div>
                        </div>
                        <div class="qr-container">
                            <img src="./assets/applestore.png" *ngIf="selectedStore == 'Apple'">

                            <img src="./assets/playstore_qr.png" *ngIf="selectedStore == 'Playstore'">

                            <img src="./assets/huawei.png" *ngIf="selectedStore == 'Huawei'">
                        </div>
                    </div>
                    <div class="footer pb-4 pt-5">
                        <button mat-button (click)="goToHomePage()">{{translation['GoBacktoHomePage']}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>